module.exports = __webpack_public_path__ + "static/tarif-bg-a6b47b35f81b2ebbc595d280bd2e54b3.png";